import { CreateRouterOptions } from '@/typings/common'
import { RouteConfig, Route } from 'vue-router'

import {
  AUTH_ROUTES as ROUTES,
} from './utils'

import { authStoreModule, registerModule } from './store'
import { StorageService } from '@/helpers/storage.service'
import { LK_PUBLICATIONS_ROUTES } from '@/views/LKPublications/utils'
import { lkStoreModule } from '@/store/modules/lk'
import { SERVICE_LK } from '@/helpers/enums/menu-folders'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const isLocalLogin = process.env.VUE_APP_AUTH_LOCAL === 'true'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createRoutes = ({ store, logout, router }: Options): RouteConfig[] => [
  {
    path: '/login',
    name: ROUTES.LOGIN,
    beforeEnter(to, from, next) {
      const StoreModule = authStoreModule.context(store)
      const LkStoreModule = lkStoreModule.context(store)

      const isOk = (
        !!to.params.authorized
          || !StoreModule.getters.authorized
      )

      LkStoreModule.mutations.reset()

      if (isOk) {
        if (isLocalLogin) {
          next()
        } else {
          const url = `${window.location.origin}/auth-service`
          const href = new URL(url)
          href.searchParams.set('url', window.location.href)
          window.location.replace(href.toString())
        }
      } else {
        next('/')
      }
    },
    component: (): PromiseVue => import(
      /* webpackChunkName: "auth-login.index" */
      './AuthLogin.vue'
    ),
  },
  {
    path: '/logout',
    name: ROUTES.LOGOUT,
    async beforeEnter(to: Route, from, next) {
      const StoreModule = authStoreModule.context(store)
      const LkStoreModule = lkStoreModule.context(store)

      let logoutUser

      if (to.params.authorized !== 'false') {
        logoutUser = StoreModule.actions.logoutUser()
      }

      // if (isLocalLogin) {
      //   StoreModule.mutations.setAuthorized(false)
      // }

      const homeRoutes = [
          LK_PUBLICATIONS_ROUTES.VIEW as string,
          LK_PUBLICATIONS_ROUTES.LIST as string,
      ]
      const toHomeReloading = homeRoutes.includes(from.name as string)

      try {
        await logoutUser
      } finally {
        LkStoreModule.mutations.reset()
        StorageService.formDataDraft.clear()
        await store.dispatch('logout')
        if (toHomeReloading) {
          window.location.replace(SERVICE_LK.route.name) // next('/') + logout()
        } else if (to.params?.toHome) {
          next('/')
        } else if (to.params?.toAuth) {
          next({ name: ROUTES.LOGIN })
        } else {
          logout() // @/helpers/logout - это просто перезапуск страницы.
        }
      }
    },
  },
]

const createModule = (options: Options): RouteConfig[] => {
  const routes = createRoutes(options)
  registerModule(options)
  return routes
}

export default createModule
